export default __webpack_public_path__ + "static/media/reusable-components-icon.97c5d99e.svg";